export default "__VITE_ASSET__ClV3YTy0__"